/** Static UI metadata: agents, statuses. Technical ids are never translated. */

export const AGENTS = {
  ORCHESTRATOR: { persona: "OneGate Orchestrator", short: "OG", classes: "bg-slate-100 text-slate-900 border-slate-200", dot: "bg-slate-500" },
  CONTENT_AGENT: { persona: "Lina", short: "LI", classes: "bg-orange-50 text-orange-900 border-orange-200", dot: "bg-orange-400" },
  INTELLIGENCE_AGENT: { persona: "Iris", short: "IR", classes: "bg-sky-50 text-sky-900 border-sky-200", dot: "bg-sky-500" },
  SALES_AGENT: { persona: "Noah", short: "NO", classes: "bg-emerald-50 text-emerald-900 border-emerald-200", dot: "bg-emerald-500" },
  MEETINGS_AGENT: { persona: "Eliott", short: "EL", classes: "bg-amber-50 text-amber-950 border-amber-200", dot: "bg-amber-500" },
  PROPOSALS_AGENT: { persona: "Gabriel", short: "GA", classes: "bg-indigo-50 text-indigo-950 border-indigo-200", dot: "bg-indigo-500" },
  COMMERCE_AGENT: { persona: "Jade", short: "JA", classes: "bg-rose-50 text-rose-900 border-rose-200", dot: "bg-rose-400" },
  AUTOMATION: { persona: "Automation", short: "AU", classes: "bg-slate-100 text-slate-900 border-slate-200", dot: "bg-slate-400" },
};

export const STATUS_CLASSES = {
  // content
  idea: "bg-slate-100 text-slate-900 border-slate-200",
  draft: "bg-slate-100 text-slate-900 border-slate-200",
  pending_approval: "bg-amber-50 text-amber-950 border-amber-200",
  approved: "bg-emerald-50 text-emerald-900 border-emerald-200",
  scheduled: "bg-sky-50 text-sky-900 border-sky-200",
  published: "bg-emerald-100 text-emerald-950 border-emerald-200",
  rejected: "bg-rose-50 text-rose-900 border-rose-200",
  failed: "bg-rose-50 text-rose-900 border-rose-200",
  // leads
  new: "bg-sky-50 text-sky-900 border-sky-200",
  contacted: "bg-amber-50 text-amber-950 border-amber-200",
  qualified: "bg-emerald-50 text-emerald-900 border-emerald-200",
  unqualified: "bg-slate-100 text-slate-900 border-slate-200",
  converted: "bg-emerald-100 text-emerald-950 border-emerald-200",
  lost: "bg-rose-50 text-rose-900 border-rose-200",
  won: "bg-emerald-100 text-emerald-950 border-emerald-200",
  open: "bg-sky-50 text-sky-900 border-sky-200",
  // approvals / runs / tasks
  pending: "bg-amber-50 text-amber-950 border-amber-200",
  expired: "bg-slate-100 text-slate-900 border-slate-200",
  running: "bg-sky-50 text-sky-900 border-sky-200",
  queued: "bg-slate-100 text-slate-900 border-slate-200",
  succeeded: "bg-emerald-50 text-emerald-900 border-emerald-200",
  awaiting_approval: "bg-amber-50 text-amber-950 border-amber-200",
  todo: "bg-slate-100 text-slate-900 border-slate-200",
  in_progress: "bg-sky-50 text-sky-900 border-sky-200",
  done: "bg-emerald-50 text-emerald-900 border-emerald-200",
  cancelled: "bg-slate-100 text-slate-900 border-slate-200",
  // sales messages
  validation: "bg-amber-50 text-amber-950 border-amber-200",
  sent: "bg-sky-50 text-sky-900 border-sky-200",
  replied: "bg-emerald-50 text-emerald-900 border-emerald-200",
  // integrations
  not_connected: "bg-slate-100 text-slate-900 border-slate-200",
  mock: "bg-amber-50 text-amber-950 border-amber-200",
  connected: "bg-emerald-50 text-emerald-900 border-emerald-200",
  error: "bg-rose-50 text-rose-900 border-rose-200",
  // orgs / misc
  trial: "bg-sky-50 text-sky-900 border-sky-200",
  active: "bg-emerald-50 text-emerald-900 border-emerald-200",
  suspended: "bg-rose-50 text-rose-900 border-rose-200",
  analyzed: "bg-emerald-50 text-emerald-900 border-emerald-200",
  accepted: "bg-emerald-100 text-emerald-950 border-emerald-200",
  completed: "bg-emerald-50 text-emerald-900 border-emerald-200",
  no_show: "bg-rose-50 text-rose-900 border-rose-200",
  high: "bg-rose-50 text-rose-900 border-rose-200",
  urgent: "bg-rose-100 text-rose-950 border-rose-200",
  normal: "bg-slate-100 text-slate-900 border-slate-200",
  low: "bg-slate-50 text-slate-700 border-slate-200",
};

export const PLATFORMS = ["instagram", "facebook", "linkedin", "tiktok", "google_business", "newsletter", "blog", "pinterest"];
export const CONTENT_FORMATS = ["post", "carousel", "reel", "story", "video_script", "article", "gbp_post"];
export const LEAD_STATUSES = ["new", "contacted", "qualified", "unqualified", "converted", "lost"];
export const LEAD_SOURCES = ["manual", "post", "ad", "comment", "dm", "form", "prospecting", "call", "campaign", "referral", "website", "import"];
export const TASK_STATUSES = ["todo", "in_progress", "done", "cancelled"];
export const PRIORITIES = ["low", "normal", "high", "urgent"];
export const AGENT_MODES = ["MANUAL", "APPROVAL_REQUIRED", "AUTOMATIC"];
export const ROLES = ["owner", "admin", "member", "viewer"];
